module.exports = __webpack_public_path__ + "img/body-3-lg.9d27b5d5.png";